import Box from '@mui/material/Box';
import { Outlet } from 'react-router';

import { useDocumentLang } from '@/modules/i18n/useDocumentLang';
import { useLanguage } from '@/modules/routing';

import Header from './Header';
import SiteMap from './SiteMap';
import { styles } from './style';

const PublicLayout = () => {
    useDocumentLang(useLanguage());
    return (
        <Box sx={styles.layout}>
            <Header/>
            <Box sx={styles.page}>
                <SiteMap/>
                <Outlet/>
            </Box>
        </Box>
    );
};

export default PublicLayout;
